var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeaturedProductSectionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.4971 29C37.3255 29 37.9971 29.6716 37.9971 30.5V36.5C37.9971 37.3284 37.3255 38 36.4971 38H30.4971C29.6686 38 28.9971 37.3284 28.9971 36.5V30.5C28.9971 29.6716 29.6686 29 30.4971 29H36.4971ZM25.5 29C26.3284 29 27 29.6716 27 30.5V36.5C27 37.3284 26.3284 38 25.5 38H19.5C18.6716 38 18 37.3284 18 36.5V30.5C18 29.6716 18.6716 29 19.5 29H25.5ZM36.297 30.7H30.697V36.3H36.297V30.7ZM25.3 30.7H19.7V36.3H25.3V30.7ZM25.5 18C26.3284 18 27 18.6716 27 19.5V25.5C27 26.3284 26.3284 27 25.5 27H19.5C18.6716 27 18 26.3284 18 25.5V19.5C18 18.6716 18.6716 18 19.5 18H25.5ZM36.4971 18C37.3255 18 37.9971 18.6716 37.9971 19.5V25.5C37.9971 26.3284 37.3255 27 36.4971 27H30.4971C29.6686 27 28.9971 26.3284 28.9971 25.5V19.5C28.9971 18.6716 29.6686 18 30.4971 18H36.4971ZM25.3 19.7H19.7V25.3H25.3V19.7ZM36.297 19.7H30.697V25.3H36.297V19.7Z",
    fill: "#1A181E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturedProductSectionIcon);
export default __webpack_public_path__ + "static/media/featured-product-section-icon.b98a61abaa0518de19162bd7b4207a77.svg";
export { ForwardRef as ReactComponent };